import {
  type CreateProductLineBody,
  type ProductCenterProductsQuery,
  type ProductCenterProductsResponse,
  type ProductLine,
  productCenterProductsResponseSchema,
  productLineResponseSchema,
  productLinesResponseSchema,
} from "@adpilot/shared";
import { api } from "./api";

/** Explicit analytics scope takes precedence over the legacy current-shop header. */
export async function fetchProductCenterProducts(
  query: ProductCenterProductsQuery,
  signal?: AbortSignal,
): Promise<ProductCenterProductsResponse> {
  const response = await api
    .get("product-center/products", {
      signal,
      searchParams: {
        ...(query.shopIds?.length ? { shopIds: query.shopIds.join(",") } : {}),
        startDate: query.startDate,
        endDate: query.endDate,
        dimension: query.dimension,
        page: query.page,
        pageSize: query.pageSize,
        active: query.active,
        sortBy: query.sortBy,
        sortDirection: query.sortDirection,
        ...(query.search ? { search: query.search } : {}),
        ...(query.availability ? { availability: query.availability } : {}),
        ...(query.productStatus ? { productStatus: query.productStatus } : {}),
        ...(query.productLineIds?.length ? { productLineIds: query.productLineIds.join(",") } : {}),
        ...(query.asins?.length ? { asins: query.asins.join(",") } : {}),
      },
    })
    .json<unknown>();

  return productCenterProductsResponseSchema.parse(response);
}

export async function fetchProductLines(
  signal?: AbortSignal,
  shopIds?: string[],
): Promise<ProductLine[]> {
  const response = await api
    .get("product-center/product-lines", {
      signal,
      ...(shopIds?.length ? { searchParams: { shopIds: shopIds.join(",") } } : {}),
    })
    .json<unknown>();
  return productLinesResponseSchema.parse(response).data;
}

export async function createProductLine(
  input: CreateProductLineBody,
  shopId?: string,
): Promise<ProductLine> {
  const response = await api
    .post("product-center/product-lines", {
      json: input,
      ...(shopId ? { headers: { "X-Shop-Id": shopId } } : {}),
    })
    .json<unknown>();
  return productLineResponseSchema.parse(response).data;
}
